import {
  SPI,
  FormFieldWidget,
  ViewType,
  ModelFieldType,
  FormEnumFieldWidget,
  Widget,
  RuntimeEnumerationOption
} from '@kunlun/dependencies';
import { fundAmountTypeChangeEventBus } from '../FundAmountTypeField';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    model: ['deli.aries.platform.fund.DeliAriesPlatformDisCreditFBLimitOrderProxy'],
    ttype: ModelFieldType.Enum,
    multi: false,
    name: 'direct'
  })
)
export class DisCreditFBLimitOrderModifyDirectFieldWidget extends FormEnumFieldWidget {
  initialize(props: any): this {
    super.initialize(props);
    return this;
  }

  @Widget.Method()
  protected getAvailableOptions(): RuntimeEnumerationOption[] {
    const parentAvailableOptions = super.getAvailableOptions();
    fundAmountTypeChangeEventBus.value &&
      fundAmountTypeChangeEventBus.value.subscribeMap(this, (val) => {
        if (
          val === 'TEMPORARY' &&
          parentAvailableOptions &&
          parentAvailableOptions.length &&
          parentAvailableOptions.length > 0
        ) {
          for (let i = 0; i < parentAvailableOptions.length; i++) {
            if (parentAvailableOptions[i] && parentAvailableOptions[i].value === 'INCREASE') {
              this.updateValue(parentAvailableOptions[i].value);
              break;
            }
          }
        }
      });
    return parentAvailableOptions;
  }
}
